import { Injectable } from '@angular/core';
import { MIXPANEL_TOKEN } from '../environments/environment';
import * as mixpanel from 'mixpanel-browser';


@Injectable()
export class MixpanelService {
  private mixpanelToken: string;

  /**
   * constructor
   * get mixpanel token and initialize
   */
  constructor() {
    this.mixpanelToken = MIXPANEL_TOKEN;

    this.init();
  }

  /**
   * Initialize mixpanel.
   */
  init(): void {
    mixpanel.init(this.mixpanelToken, {track_pageview: true});
  }


  /**
   * Create new Alias for user
   * Call this method only once in user lifecycle
   *
   * @param {string} alias
   */
  createAlias(alias: string) {
    mixpanel.alias(alias, mixpanel.get_distinct_id());
  }

  /**
   * Identify User
   *
   * @param {string} alias
   */
  identify(alias: string) {
    mixpanel.identify(alias);
  }

  /**
   * Push new action to mixpanel.
   *
   * @param {string} id Name of the action to track.
   * @param {*} [action={}] Actions object with custom properties.
   * @memberof MixpanelService
   */
  track(id: string, action: any = {}): void {
    mixpanel.track(id, action);
  }

  /**
   * setup mixpannel
   *
   */
  setup() {
    this.setSuperProperties({ Platform: 'web' });
  }

  /**
   * setPeople
   * Store user profiles in Mixpanel's People Analytics product
   * @param {Object} properties
   */
  setPeople(properties: any = {}): void {
    mixpanel.people.set(properties);
  }

  /**
   * setSuperProperties
   *
   * @param {object} properties
   */
  setSuperProperties(properties) {
    mixpanel.register(properties);
  }

  /**
   * sendEvent
   *
   * @param {string} event
   * @param {object} properties
   */
  sendEvent(event: string, properties?) {
    if (properties) {
      mixpanel.track(event, properties);
    } else {
      this.trackEvent(event, '');
    }
  }

  /**
   * trackEvent
   * @param {string} event
   * @param {string} [pageName='']
   * @param {string} [userName='']
   * @param {string} [email='']
   */
  trackEvent(event: string, pageName: string = '', userName: string = '', email: string = '') {
    mixpanel.track(event, {pageName, userName, email});

  }

  /**,
   * Reset Mixpanel
   */
  logout() {
    mixpanel.reset();
  }
}
